import React, { useState } from "react";
import axios from "axios";

import Results from "./Results";
import Photos from "./photos/Photos";

import "./Dictionary.css";

export default function Dictionary() {
  let [keyword, setKeyword] = useState("");
  let [results, setResults] = useState(null);
  let [photos, setPhotos] = useState(null);

  function handleDictionaryResponse(response) {
    // Just display the first definition of the response
    setResults(response.data[0]);
  }

  function handleDictionaryError(response) {
    alert(`${keyword} is not a valid word`);
  }

  function executePexelsRequest() {
    const pexelsApiKey =
      "563492ad6f91700001000001eedbf5d9515949eeb79137ff0e8a0467";
    let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=4`;
    axios
      .get(pexelsApiUrl, {
        headers: { Authorization: `Bearer ${pexelsApiKey}` },
      })
      .then(handlePexelsResponse);
  }

  function handlePexelsResponse(response) {
    setPhotos(response.data.photos);
  }

  function Search(event) {
    event.preventDefault(); // stops the default page refresh behaviour
    // Only continue if the keyword is not null or whitespace
    if (keyword) {
      // Documentation: https://dictionaryapi.dev/
      let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
      axios
        .get(apiUrl)
        .then(handleDictionaryResponse)
        .then(executePexelsRequest) // Ensures that if the word is not valid, to not update the images
        .catch(handleDictionaryError);
    }
  }

  function handleKeywordChange(event) {
    setKeyword(event.target.value);
  }

  return (
    <div className="Dictionary">
      <section id="searchSection">
        <h4>What word would you like to look up?..</h4>
        <form onSubmit={Search}>
          <input
            id="search"
            type="search"
            placeholder="Type something..."
            autoFocus={true}
            onChange={handleKeywordChange}
          />
          <button id="searchBtn" type="submit">
            🔎
          </button>
        </form>
        <p>
          Suggested words: <i>spaghetti, kitten, reflection</i>
        </p>
      </section>
      <Results results={results} />
      <Photos photos={photos} />
    </div>
  );
}
